import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import RefreshIcon from "@mui/icons-material/Refresh";
import type { ReactNode } from "react";

function ErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 4,
        minHeight: 200,
      }}
      role="alert"
    >
      <Typography variant="h6" gutterBottom>
        Something went wrong
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {error.message || "An unexpected error occurred"}
      </Typography>
      <Button
        variant="contained"
        startIcon={<RefreshIcon />}
        onClick={resetErrorBoundary}
      >
        Try again
      </Button>
    </Box>
  );
}

export const AppErrorBoundary = ({ children }: { children: ReactNode }) => (
  <ReactErrorBoundary FallbackComponent={ErrorFallback}>
    {children}
  </ReactErrorBoundary>
);
